<ul class="sidebar-menu" *ngIf="show_menu">
  <li>
    <a
      routerLink="/school/dashboard"
      routerLinkActive="active-link"
      matTooltip="Dashboard"
      matTooltipPosition="right"
    >
      <span class="nav-title">Dashboard</span>
      <span><img src="assets/images/dashboard.svg" alt="" /></span>
    </a>
  </li>
</ul>

<ul class="sidebar-footer">
  <li>
    <a
      routerLink="/school/settings"
      routerLinkActive="active-link"
      matTooltip="Settings"
      matTooltipPosition="right"
    >
      <span class="nav-title">Settings</span>
      <span><img src="assets/images/settings.svg" alt="" /></span>
    </a>
  </li>
  <li>
    <a
      href="javascript:;"
      (click)="logout()"
      matTooltip="Logout"
      matTooltipPosition="right"
    >
      <span><img src="assets/images/logout.svg" alt="" /></span>
      <span class="nav-title">Logout</span>
    </a>
  </li>
</ul>
